import { createAction } from '@reduxjs/toolkit';

import { IAbstractResponse } from './types';

export class GetCurrentLocationSuccess {
  static get action() {
    return createAction<IAbstractResponse>('profile/GET_CURRENT_LOCATION_SUCCESS');
  }
}
